import React, { Component } from 'react';
import axios from 'axios';
import { shipping_methods, get_shipping_method } from '../../../repository';
import { withCookies, Cookies } from 'react-cookie';

const cookies = new Cookies();

let BASE_URL;
let ASSETS_URL;

if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
    BASE_URL = 'http://localhost:8001';
    ASSETS_URL = ""
}else if (window.location.hostname === 'dev.cocoonsealy.net'){
    BASE_URL = 'http://dev.cocoonsealy.net';
    ASSETS_URL = "http://dev.cocoonsealy.net"
}else if (window.location.hostname === 'staging.cocoonbysealy.ca'){
    BASE_URL = 'https://staging.cocoonbysealy.ca';
    ASSETS_URL = "https://staging.cocoonbysealy.ca"
}else{
    BASE_URL = 'https://cocoonbysealy.ca';
    ASSETS_URL = "https://assets-www.cocoonbysealy.ca"
}

// console.log(`(delivery) window location is: `, window.location.hostname);

class Delivery extends Component {    
    saveAndContinue = (e) => {
        e.preventDefault();
        this.props.disable_delivery_button(true);
        const method = {
            country: `${BASE_URL}/api/countries/CA/`,
            line1: this.props.values.shipping_line1,
            line2: this.props.values.shipping_line2,
            line4: this.props.values.shipping_line4,
            postcode: this.props.values.shipping_postcode,
            state: this.props.values.shipping_state,             
        }
        const userlang = cookies.get('cbs_language');
        // shipping_methods(method)

        // .then( (data) => {
        //     console.log(`Shipping Mehods set to`, data);
        //     this.props.nextStep()
        // }) 
        const b = false;

        get_shipping_method(method, b, this.props.userlang)

        .then( (data) => {
            if (data  !== undefined  && data.Status === true) {
                //console.log(`Shipping Mehods set to`, data.Method);
                this.props.get_cbs_language_cookie();
                this.props.nextStep();
            }else{
                // this.props.disable_delivery_button(false);
                // console.log(data) 
                if (this.props.userlang === 'fr') {
                    alert('En raison de circonstances imprévues, la méthode de livraison n’a pas été établie. Veuillez réessayer, et si le problème persiste, nous vous prions de communiquer avec l’équipe de soutien.');
                }else{
                    alert('Due to an unforseen issue, the Shipping method not set. Please try again and if the problem persist please contact support.');
                }                
            }

            // this.props.nextStep();
            
        })
        
        
    }

    back  = (e) => {
        e.preventDefault();
        this.props.get_cbs_language_cookie();
        this.props.disable_delivery_button(false);
        this.props.disable_ship_button(false);
        this.props.disable_billing_button(false);  
        this.props.prevStep();
    }

    home = (e) => {
        e.preventDefault();
        this.props.defaultStep(2);
    }

    componentDidMount = () => {
        // console.log("Delivery Props", this.props)
    }
    
    render(){        
        const basket_lines = this.props.basket_lines;
        return(
            <React.Fragment>
                {/*<!-- Delivery Form/ Summary--> */}
                <div className="checkout-step checkout-step--shipping-method form">
                    <h2 className="checkout-step__heading">2. {this.props.userlang ==='fr'? 'Poursuivre vers Livraison': 'Delivery'}</h2>
                    <div className={this.props.step > 2? 'checkout-step__body checkout-step__body--collapsed' :'checkout-step__body'}>
                        <form className="form">
                            <div className="form__field"></div>
                            <div className="checkout-step__shipping-group">
                                <h2 className="checkout-step__subheading">{this.props.userlang ==='fr'? 'Article(s)': 'ITEM(S)'}:</h2>
                                {/* Basket Items */}
                                {basket_lines.map( (line, index) => (
                                parseFloat(basket_lines[index].price_excl_tax_excl_discounts) > parseFloat(basket_lines[index].price_excl_tax)?
                                <React.Fragment >
                                <div key={index} className="basket-line basket-line--minimal">                                    
                                    <div className="basket-line__graphic">
                                    <a
                                                        href={ this.props.get_product_url(line.product) }>                                                                                   

                                        {                                                        
                                            (() => {
                                                if (this.props.get_product_category(line.product) === "cocoon-classic") {
                                                    return (
                                                    <img src={ASSETS_URL + "/media/original_images/cocoon_classic.original.jpg"}
                                                    className="basket-line__graphic__image" alt={ this.props.get_product_title(line.product) } />)
                                                } else if (this.props.get_product_category(line.product) === "cocoon-essential") {
                                                    return(
                                                        <img src={ASSETS_URL + "/media/original_images/Cocoon-8IN-Shop-Section.png"}
                                                        className="basket-line__graphic__image" alt={ this.props.get_product_title(line.product) } />
                                                    );
                                                } else if (this.props.get_product_category(line.product) === "sealy-essential") {
                                                    return(
                                                        <img src={ASSETS_URL + "/media/original_images/essentials-pillow-optimized.png"}
                                                        className="basket-line__graphic__image" alt={ this.props.get_product_title(line.product) } />
                                                    );
                                                } else if (this.props.get_product_category(line.product) === "sealy-premium") {
                                                    return(
                                                        <img src={ASSETS_URL + "/media/original_images/premium-pillow-optimized.png"}
                                                        className="basket-line__graphic__image" alt={ this.props.get_product_title(line.product) } />
                                                    );
                                                } else if (this.props.get_product_category(line.product) === "sealy-performance") {
                                                    return(
                                                        <img src={ASSETS_URL + "/media/original_images/performance-pillow-optimized.png"}
                                                        className="basket-line__graphic__image" alt={ this.props.get_product_title(line.product) } />
                                                    );
                                                }
                                            })()
                                        }

                                        </a>
                                    </div>
                                    <div className="basket-line__details">
                                        <div className="basket-line__details__row">
                                            <div className="basket-line__details__product-title">
                                                <h3>
                                                    <a href={ this.props.get_product_url(line.product) } target="_blank">{ this.props.get_product_title(line.product) }</a>
                                                </h3>
                                            </div>
                                            <div className="basket-line__details__qty">
                                                <p>{this.props.userlang ==='fr'? 'Qté': 'Qty'}: {basket_lines[index].quantity}</p>
                                            </div>
                                            <div className="basket-line__details__price">
                                                <span
                                                    className="basket-line__details__price--strike">${basket_lines[index].price_excl_tax_excl_discounts}</span>
                                                <span
                                                    className="basket-line__details__price">${basket_lines[index].price_excl_tax}</span>
                                            </div>
                                        </div>
                                        <div className="basket-line__details__row">
                                            <div className="basket-line__details__options">
                                                <ul></ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                </React.Fragment>
                                :
                                <React.Fragment >
                                <div key={index} className="basket-line basket-line--minimal">                                    
                                    <div className="basket-line__graphic">
                                    <a
                                                        href={ this.props.get_product_url(line.product) }>                                                                                   

                                        {                                                        
                                            (() => {
                                                if (this.props.get_product_category(line.product) === "cocoon-classic") {
                                                    return (
                                                    <img src={ASSETS_URL + "/media/original_images/cocoon_classic.original.jpg"}
                                                    className="basket-line__graphic__image" alt={ this.props.get_product_title(line.product) } />)
                                                } else if (this.props.get_product_category(line.product) === "cocoon-essential") {
                                                    return(
                                                        <img src={ASSETS_URL + "/media/original_images/Cocoon-8IN-Shop-Section.png"}
                                                        className="basket-line__graphic__image" alt={ this.props.get_product_title(line.product) } />
                                                    );
                                                } else if (this.props.get_product_category(line.product) === "sealy-essential") {
                                                    return(
                                                        <img src={ASSETS_URL + "/media/original_images/essentials-pillow-optimized.png"}
                                                        className="basket-line__graphic__image" alt={ this.props.get_product_title(line.product) } />
                                                    );
                                                } else if (this.props.get_product_category(line.product) === "sealy-premium") {
                                                    return(
                                                        <img src={ASSETS_URL + "/media/original_images/premium-pillow-optimized.png"}
                                                        className="basket-line__graphic__image" alt={ this.props.get_product_title(line.product) } />
                                                    );
                                                } else if (this.props.get_product_category(line.product) === "sealy-performance") {
                                                    return(
                                                        <img src={ASSETS_URL + "/media/original_images/performance-pillow-optimized.png"}
                                                        className="basket-line__graphic__image" alt={ this.props.get_product_title(line.product) } />
                                                    );
                                                }
                                            })()
                                        }

                                        </a>
                                    </div>
                                    <div className="basket-line__details">
                                        <div className="basket-line__details__row">
                                            <div className="basket-line__details__product-title">
                                                <h3>
                                                <a href={ this.props.get_product_url(line.product) } target="_blank">{ this.props.get_product_title(line.product) }</a>
                                                </h3>
                                            </div>
                                            <div className="basket-line__details__qty">
                                                <p>{this.props.userlang ==='fr'? 'Qté': 'Qty'}: {basket_lines[index].quantity}</p>
                                            </div>
                                            <div className="basket-line__details__price">                                                
                                                <span
                                                    className="basket-line__details__price">${basket_lines[index].price_excl_tax_excl_discounts}</span>
                                            </div>
                                        </div>
                                        <div className="basket-line__details__row">
                                            <div className="basket-line__details__options">
                                                <ul></ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                </React.Fragment>                                                
                                ))}  
                                {/* EOF Basket Items  */}
                                <h2 className="checkout-step__subheading">{this.props.userlang ==='fr'? 'Méthode de livraison': 'SHIPPING METHOD'}:</h2>
                                <div className="checkout-step__methods">
                                    <div className="form__field form__field--optional form__field--radio form__field--shipping_method_0 form__field--not-blank">
                                        <label>
                                            <input name="shipping_method_0" type="radio" value="standard" checked="checked" disabled={true} />
                                            {this.props.userlang ==='fr'? 'Livraison avec Fedex Ground': 'Fedex Ground Shipping'} - $0.00</label>
                                    </div>
                                </div>
                            </div>
                            {/* <!-- Delivery Notes not used in this form but do not remove --> */}
                            <div>
                                <p className="checkout-step__notes-show" id="show-notes"><a
                                        className="checkout-step__notes-show--link" href="#"><span
                                            className="checkout-step__notes__arrow-right"></span>Add delivery notes
                                        (optional)</a></p>
                                <div className="checkout-step__notes--collapsed">
                                    <div
                                        className="form__field form__field--optional form__field--textbox form__field--shipping_notes">
                                        <label className="form__label form__label--dynamic" htmlFor="shipping_notes">Enter
                                            delivery notes...</label><textarea id="shipping_notes"
                                            name="shipping_notes" type="textbox" rows="1" cols="50"
                                            maxLength="70"></textarea></div>
                                </div>
                            </div>
                            {/* <!-- EOF Delivery Notes --> */}
                            <div className="form__field form__field--submit"><input type="submit"
                                    className="button button--full-width button--continue-to-billing"
                                    value={this.props.userlang ==='fr'? 'Poursuivre vers Facturation': 'Continue to Billing'} onClick={this.saveAndContinue} disabled={this.props.submit_delivery?true:false} /></div>
                        </form>
                    </div>
                    <div className={this.props.step === 2? "checkout-step__summary checkout-step__summary--collapsed" :"checkout-step__summary"}>
                            <div className="checkout-step__shipping-group-summary">
                                <h3 className="checkout-step__label">{this.props.userlang ==='fr'? 'Livraison avec Fedex Ground': 'Fedex Ground Shipping'}:</h3>
                                <p></p>
                                
                                {/* Basket Items */}
                                {basket_lines.map( (line, index) => (
                                parseFloat(basket_lines[index].price_excl_tax_excl_discounts) > parseFloat(basket_lines[index].price_excl_tax)?
                                <React.Fragment >
                                <div key={index} className="basket-line basket-line--minimal">
                                    <div className="basket-line__graphic">
                                    <a
                                                        href={ this.props.get_product_url(line.product) }>                                                                                   

                                        {                                                        
                                            (() => {
                                                if (this.props.get_product_category(line.product) === "cocoon-classic") {
                                                    return (
                                                    <img src={ASSETS_URL + "/media/original_images/cocoon_classic.original.jpg"}
                                                    className="basket-line__graphic__image" alt={ this.props.get_product_title(line.product) } />)
                                                } else if (this.props.get_product_category(line.product) === "cocoon-essential") {
                                                    return(
                                                        <img src={ASSETS_URL + "/media/original_images/Cocoon-8IN-Shop-Section.png"}
                                                        className="basket-line__graphic__image" alt={ this.props.get_product_title(line.product) } />
                                                    );
                                                } else if (this.props.get_product_category(line.product) === "sealy-essential") {
                                                    return(
                                                        <img src={ASSETS_URL + "/media/original_images/essentials-pillow-optimized.png"}
                                                        className="basket-line__graphic__image" alt={ this.props.get_product_title(line.product) } />
                                                    );
                                                } else if (this.props.get_product_category(line.product) === "sealy-premium") {
                                                    return(
                                                        <img src={ASSETS_URL + "/media/original_images/premium-pillow-optimized.png"}
                                                        className="basket-line__graphic__image" alt={ this.props.get_product_title(line.product) } />
                                                    );
                                                } else if (this.props.get_product_category(line.product) === "sealy-performance") {
                                                    return(
                                                        <img src={ASSETS_URL + "/media/original_images/performance-pillow-optimized.png"}
                                                        className="basket-line__graphic__image" alt={ this.props.get_product_title(line.product) } />
                                                    );
                                                }
                                            })()
                                        }

                                        </a>
                                    </div>
                                    <div className="basket-line__details">
                                        <div className="basket-line__details__row">
                                            <div className="basket-line__details__product-title">
                                                <h3>
                                                <a href={ this.props.get_product_url(line.product) } target="_blank">{ this.props.get_product_title(line.product) }</a>
                                                </h3>
                                            </div>
                                            <div className="basket-line__details__qty">
                                                <p>{this.props.userlang ==='fr'? 'Qté': 'Qty'}: {basket_lines[index].quantity}</p>
                                            </div>
                                            <div className="basket-line__details__price">
                                                <span
                                                    className="basket-line__details__price--strike">${basket_lines[index].price_excl_tax_excl_discounts}</span>
                                                <span
                                                    className="basket-line__details__price">${basket_lines[index].price_excl_tax}</span>
                                            </div>
                                        </div>
                                        <div className="basket-line__details__row">
                                            <div className="basket-line__details__options">
                                                <ul></ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                </React.Fragment>
                                :
                                <React.Fragment >
                                <div key={index} className="basket-line basket-line--minimal">
                                    <div className="basket-line__graphic">
                                    <a
                                                        href={ this.props.get_product_url(line.product) }>                                                                                   

                                        {                                                        
                                            (() => {
                                                if (this.props.get_product_category(line.product) === "cocoon-classic") {
                                                    return (
                                                    <img src={ASSETS_URL + "/media/original_images/cocoon_classic.original.jpg"}
                                                    className="basket-line__graphic__image" alt={ this.props.get_product_title(line.product) } />)
                                                } else if (this.props.get_product_category(line.product) === "cocoon-essential") {
                                                    return(
                                                        <img src={ASSETS_URL + "/media/original_images/Cocoon-8IN-Shop-Section.png"}
                                                        className="basket-line__graphic__image" alt={ this.props.get_product_title(line.product) } />
                                                    );
                                                } else if (this.props.get_product_category(line.product) === "sealy-essential") {
                                                    return(
                                                        <img src={ASSETS_URL + "/media/original_images/essentials-pillow-optimized.png"}
                                                        className="basket-line__graphic__image" alt={ this.props.get_product_title(line.product) } />
                                                    );
                                                } else if (this.props.get_product_category(line.product) === "sealy-premium") {
                                                    return(
                                                        <img src={ASSETS_URL + "/media/original_images/premium-pillow-optimized.png"}
                                                        className="basket-line__graphic__image" alt={ this.props.get_product_title(line.product) } />
                                                    );
                                                } else if (this.props.get_product_category(line.product) === "sealy-performance") {
                                                    return(
                                                        <img src={ASSETS_URL + "/media/original_images/performance-pillow-optimized.png"}
                                                        className="basket-line__graphic__image" alt={ this.props.get_product_title(line.product) } />
                                                    );
                                                }
                                            })()
                                        }

                                        </a>
                                    </div>
                                    <div className="basket-line__details">
                                        <div className="basket-line__details__row">
                                            <div className="basket-line__details__product-title">
                                                <h3>
                                                <a href={ this.props.get_product_url(line.product) } target="_blank">{ this.props.get_product_title(line.product) }</a>
                                                </h3>
                                            </div>
                                            <div className="basket-line__details__qty">
                                                <p>{this.props.userlang ==='fr'? 'Qté': 'Qty'}: {basket_lines[index].quantity}</p>
                                            </div>
                                            <div className="basket-line__details__price">                                                
                                                <span
                                                    className="basket-line__details__price">${basket_lines[index].price_excl_tax_excl_discounts}</span>
                                            </div>
                                        </div>
                                        <div className="basket-line__details__row">
                                            <div className="basket-line__details__options">
                                                <ul></ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                </React.Fragment>                                                
                                ))}  


                            </div>
                        <p><a className="checkout-step__back" href="#" onClick={
                            
                            this.props.step > 3? this.home : this.back

                            }>{this.props.userlang ==='fr'? 'Modifier': 'Edit'}</a></p>
                    </div>
                    
                </div>
                {/* <!-- End of Delivery/Summary -->*/}
            </React.Fragment>
        );
    }

}

export default Delivery;